import { render, staticRenderFns } from "./MediaRecorder.vue?vue&type=template&id=88aacdde&scoped=true"
import script from "./MediaRecorder.vue?vue&type=script&lang=ts"
export * from "./MediaRecorder.vue?vue&type=script&lang=ts"
import style0 from "./MediaRecorder.vue?vue&type=style&index=0&id=88aacdde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aacdde",
  null
  
)

export default component.exports